import { useBackend } from "../../services";

export const useGetShelvingProducts = () => {
  const { get } = useBackend();
  const getShelvingProducts = () => get("products/shelvings");
  return { getShelvingProducts };
};
